module.exports = __webpack_public_path__ + "img/forvestglobalca.c0325cf4.png";